import React from 'react';

import { Toast, Radio, WingBlank, Button } from 'antd-mobile'
class App extends React.Component {
    state = {
        qValue0:  0,
        qValue1:  0,
        qValue2:  0,
        qValue3:  0,
        qValue4:  0,
        qValue5:  0,
        qValue6:  0,
        qValue7:  0,
        qValue8:  0,
        qValue9:  0,
        qValue10: 0,
        qValue11: 0,
        qValue12: 0,
        qValue13: 0,
        qValue14: 0,
        qValue15: 0,
        qValue16: 0,
        qValue17: 0,
        qValue18: 0,
        qValue19: 0,
    }
    createQuestionList() {
        let questionJson = [
            {
                q: "1.我觉得比平常容易紧张和着急",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "2.我无缘无故地感到害怕",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "3.我容易心里烦乱或觉得惊恐",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "4.我觉得我可能将要发疯",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "5.我觉得一切都很好，也不会发生什么不幸",
                a: [{ value: 4, text: "A.很少" }, { value: 3, text: " B.小部分时间" }, { value: 2, text: " C.相当多的时间" }, { value: 1, text: " D.绝大部分时间" }]
            },
            {
                q: "6.我手脚发抖打颤",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "7.我因为头疼、头颈痛和背痛而苦恼",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "8.我感到容易衰弱和疲乏",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "9.我觉得心平气和，并且容易安静坐着",
                a: [{ value: 4, text: "A.很少" }, { value: 3, text: " B.小部分时间" }, { value: 2, text: " C.相当多的时间" }, { value: 1, text: " D.绝大部分时间" }]
            },
            {
                q: "10.我觉得心跳得很快",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "11.我因为一阵阵头晕而苦恼",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "12.我有晕倒发作或觉得要晕倒似的",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "13.我呼气、吸气都感到很容易",
                a: [{ value: 4, text: "A.很少" }, { value: 3, text: " B.小部分时间" }, { value: 2, text: " C.相当多的时间" }, { value: 1, text: " D.绝大部分时间" }]
            },
            {
                q: "14.我手脚麻木和刺痛",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "15.我因为胃痛和消化不良而苦恼",

                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "16.我常常要小便",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "17.我的手脚常常是干燥温暖的",
                a: [{ value: 4, text: "A.很少" }, { value: 3, text: " B.小部分时间" }, { value: 2, text: " C.相当多的时间" }, { value: 1, text: " D.绝大部分时间" }]
            },
            {
                q: "18.我脸红发热",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "19.我容易人睡，并且一夜睡得很好",
                a: [{ value: 4, text: "A.很少" }, { value: 3, text: " B.小部分时间" }, { value: 2, text: " C.相当多的时间" }, { value: 1, text: " D.绝大部分时间" }]
            },
            {
                q: "20.我做恶梦",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
        ]
        let questionList = questionJson.map((row, qIndex) => {
            return (
                <li key={qIndex}>
                    <div className="question_title">{row.q}</div>
                    <div className="answer">
                        {
                            row.a.map((a, aIndex) => {
                                return (
                                    <div key={aIndex}>
                                        <Radio className="xu_radio" onChange={() => { this.onChange(a.value, qIndex) }} checked={this.state["qValue" + qIndex] === a.value} name={"q" + qIndex} key={a.value}>{a.text}</Radio>
                                    </div>
                                )
                            })
                        }
                    </div>
                </li>
            )
        })
        return questionList
    }
    onChange(value, index) {
        let state = JSON.parse(JSON.stringify(this.state))
        state['qValue' + index] = value
        this.setState(state)
    }
    onSubmit() {
        let state = this.state
        let keys = Object.keys(state)
        let flag = keys.filter(key => {
            return state[key] === 0
        })
        if (flag.length !== 0) {
            Toast.info("题目还没有做完撒~")
        } else {
            //开始算分啦
            let totalScore = 0; //粗分
            keys.forEach(key => {
                totalScore += state[key]
            })
            let standerScore = parseInt(totalScore * 1.25) //标准分  
            if (standerScore < 50) {
                Toast.success('你没有焦虑症')
            } else if (standerScore >= 50 && standerScore < 59) {
                Toast.fail('你患有轻度焦虑')
            } else if (standerScore >= 60 && standerScore < 69) {
                Toast.fail('你患有中度焦虑')
            } else if (standerScore > 69) {
                Toast.fail('你患有重度焦虑')
            }
        }
    }
    render() {
        return (
            <div className="question_page">
                <WingBlank>
                    <h1 className='title'>焦虑自评量表（SAS）</h1>
                    <p className='desc'></p>
                    {/* <h3 className='time'></h3> */}
                    <ul className="question_list">
                        {this.createQuestionList()}
                    </ul>

                    <Button type="primary" onClick={this.onSubmit.bind(this)}>提交</Button>
                </WingBlank>
            </div>
        );
    }
}

export default App;
